import { IEntity } from '../types';
import { EntityService } from './EntityService';

export class RiskAppSeverityService extends EntityService<IEntity> {
    constructor() {
        super(`/RiskAppSeverities`);
    }
}